import React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";
import Button from "@/components/Button"; // Assuming you have a generic Button component
import usePodcast from "@/hooks/usePodcast";
import Body from "@/ui/Body";

const defaultIntro = `<p>We have built both a digital and offline community, through hosting round table discussions, webinars, interactive panels, and lightning talks.
Our latest event and podcast series – Let’s Get Disruptive, has created a unique platform for sharing experiences and discussing industry challenges.</p>`;

export const PodcastSection = ({ title, intro = "", cta, className }) => {
  const podcasts = usePodcast({ limit: 1 }); // We only need the most recent podcast for the embed
  const latestPodcast = podcasts?.[0];
  const finalIntro = intro.length > 0 ? intro : defaultIntro;

  return (
    <section id="podcasts" className={cn(styles.PodcastSection, className)}>
      {/* Main Title */}
      {title && (
        <h2 className={styles.title} data-sourceflow-prop="title">
          {title}
        </h2>
      )}

      {/* Intro Paragraph */}
      {finalIntro && (
        <div className={styles.intro}>
          <Body body={finalIntro} />
        </div>
      )}

      {/* Podcast Embed Container */}
      <div className={styles.embed_container}>
        {latestPodcast?.embed_code ? (
          // This will render the <iframe> from your CMS field
          <div dangerouslySetInnerHTML={{ __html: latestPodcast.embed_code }} />
        ) : (
          <p>No podcast embed code found.</p>
        )}
      </div>

      {/* CTA Button at the bottom */}
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <div className={styles.button}>
          <span>Join our digital community</span>
        </div>
      </div>
    </section>
  );
};

export default PodcastSection;
